import { useContext } from "react"
import { AppContext } from "../../context"
import { CustomLink } from "iuvity-ui-components";
import iuvityLogo from '../../assets/iuvity-logo.png';
import { useMediaQuery } from "iuvity-ui-components/dist/hooks";

export const Footer = () => {
  const {
    t,
  } = useContext(AppContext);

  const isBigScreen = useMediaQuery('(min-width: 1920px)');

  return (
    <div className={`footer-container pr-7 ${isBigScreen ? '' : 'pl-7'}`} >
      <div className='section-1'>
        <CustomLink
          key="privacy policy"
          content={t("Footer.policiesLabel")}
          href={`https://www.iuvity.com/en/privacy-policy-terms-and-conditions#terms`}
        />
        <CustomLink
          key="terms of use"
          content={t("Footer.termsConditionsLabel")}
          href={`https://www.iuvity.com/en/privacy-policy-terms-and-conditions#terms`}
        />
      </div>
      <div className='section-2'>
        <div>Copyright© {new Date().getFullYear()}</div>
        <div>{t("Footer.byLabel")} <img src={iuvityLogo} alt="logo" /></div>
      </div>
    </div>
  )
}
